import React, { memo } from "react";

import styles from "./style.css";

export const PortalError = memo(() => {
  return (
    <div class={styles.container}>
      <img src={`${window.GLOBALS.ASSETS.CORE}/img/portal-error.png`} />
      <header>Oops</header>
      <p>Something went wrong while loading this page. Press refresh to try again.</p>
      <button onClick={() => window.location.reload()}>Refresh</button>
    </div>
  );
});
